"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const error_1 = require("../../error");
const manager_1 = require("../../manager");
const tokens_1 = require("../../tokens");
exports.execEach = ({ ast, execObject }, last) => {
    const { manager } = execObject;
    if (last.name === tokens_1.LiteralTokens.NumberLiteralRange) {
        const eachObj = ast.toEach[0];
        const range = Array.from(Array(last.end - last.start + 1).keys(), (x) => x + last.start);
        range.forEach((i) => {
            const inManger = {
                variable: new manager_1.VariableManager(manager.variable),
                function: manager.function,
            };
            if (eachObj.children.Identifier !== undefined) {
                inManger.variable.assignment(eachObj.children.Identifier[0].image, {
                    name: tokens_1.LiteralTokens.NumberLiteral,
                    image: i,
                });
            }
            return execObject.interpreter({
                ast: eachObj.children.rules[0],
                execObject: {
                    manager: inManger,
                    interpreter: execObject.interpreter,
                },
            });
        });
        return {
            name: tokens_1.LiteralTokens.NumberLiteral,
            image: range.length,
        };
    }
    else if (last.name === tokens_1.LiteralTokens.ArrayLiteral) {
        const eachObj = ast.toEach[0];
        last.image.forEach((element) => {
            const inManger = {
                variable: new manager_1.VariableManager(manager.variable),
                function: manager.function,
            };
            if (eachObj.children.Identifier !== undefined) {
                inManger.variable.assignment(eachObj.children.Identifier[0].image, element);
            }
            return execObject.interpreter({
                ast: eachObj.children.rules[0],
                execObject: {
                    manager: inManger,
                    interpreter: execObject.interpreter,
                },
            });
        });
    }
    else {
        throw new error_1.TypeError(last.name);
    }
    return {
        name: tokens_1.LiteralTokens.DebugLiteral,
        image: null,
    };
};
